import { createSelector } from 'reselect'

const getStorefrontOwnerData = state => state.storefront.owner
const getUserData = state => state.user
const getMyAccountData = state => state.myAccount

const defaultMyAccountData ={
	userGrades: [],
	userSubjects: [],
}

const storefrontOwnerMetricsSelector = createSelector(
	[ getStorefrontOwnerData, getUserData, getMyAccountData ],
	(ownerState, userState, myAccountState) => {

		let myAccountData = {}
		if (myAccountState.data) {
			const grades = myAccountState.data.grades || []
			const gradeIds = myAccountState.data.gradeIds || []
			const subjects = myAccountState.data.subjects || []
			const subjectIds = myAccountState.data.subjectIds || []

			myAccountData.userGrades = grades.filter(grade => gradeIds.includes(grade.id)).map(grade => grade.value)
			myAccountData.userSubjects = subjects.filter(subject => subjectIds.includes(subject.id)).map(subject => subject.value)
		} else {
			myAccountData = defaultMyAccountData
		}

		const followersCount = ownerState.data && ownerState.data.owner_follow_data ? ownerState.data.owner_follow_data.data.ownerFollowersCount : ''
		const signUpDate = userState.data.created ? new Date(parseInt(userState.data.created)*1000).toISOString() : ''

		const lessonsCount = ownerState.lessons.count ? ownerState.lessons.count : ''

		const ownerId = ownerState.data.owner_follow_data ? ownerState.data.owner_follow_data.data.entityUID : ''

		return {
			'Number of Lessons': lessonsCount,
			'Number of Followers': followersCount,
			'Number of Downloads': ownerState.data.downloads,
			'Sign Up Date': signUpDate,
			'Lesson Grades': myAccountData.userGrades,
			'Lesson Subjects': myAccountData.userSubjects,
			'Owner Id': ownerId,
		}
	}
)

export default storefrontOwnerMetricsSelector
